var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTech2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3673_4609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6724 23.8868V16.1098H36.0462C35.6396 14.4245 34.9773 12.8442 34.0921 11.4016L36.656 8.83765L31.1544 3.33601L28.5904 5.89994C27.1478 5.02125 25.5675 4.3524 23.8822 3.94584V0.326172H16.1052V3.9524C14.4199 4.35896 12.8396 5.02125 11.397 5.9065L8.83304 3.34256L3.33796 8.83765L5.9019 11.4016C5.02321 12.8442 4.35435 14.4245 3.9478 16.1098H0.328125V23.8868H3.95435C4.36091 25.5721 5.02321 27.1524 5.90845 28.595L3.34452 31.159L8.84616 36.6606L11.4101 34.0967C12.8527 34.9753 14.433 35.6442 16.1183 36.0508V39.677H23.8953V36.0508C25.5806 35.6442 27.1609 34.9819 28.6035 34.0967L31.1675 36.6606L36.6691 31.159L34.1052 28.595C34.9839 27.1524 35.6527 25.5721 36.0593 23.8868H39.6855H39.6724Z",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 31.0172C26.084 31.0172 31.0162 26.085 31.0162 20.0008C31.0162 13.9166 26.084 8.98438 19.9998 8.98438C13.9156 8.98438 8.9834 13.9166 8.9834 20.0008C8.9834 26.085 13.9156 31.0172 19.9998 31.0172Z",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9246 15.4902L18.518 20.1329L16.2689 17.8574L14 20.2115L18.5377 24.8607L25.2197 17.6673L22.9246 15.4902Z",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3673_4609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTech2);
export default __webpack_public_path__ + "static/media/tech2.715671bc193a1de6d6a29bc70aa1b5d0.svg";
export { ForwardRef as ReactComponent };